export default __webpack_public_path__ + "static/media/clark.cc8de06f.png";